import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";

const Circular = styled.button`
  display: block;
  width: ${props => props.size || "32px"};
  height: ${props => props.size || "32px"};
  margin: 1em auto;
  -webkit-border-radius: 99em;
  -moz-border-radius: 99em;
  border-radius: 99em;
  background-color: ${props => props.theme.color5};
  border: 1px solid ${props => props.theme.color2}
  :hover,
  :focus,
  :active {
    background-color: ${props => props.theme.color6};
    cursor: pointer;
  }
`;

const CircularDiv = styled.div`
  -webkit-appearance: button;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0em;
  font: 400 11px system-ui;
  font-family: inherit;
  padding: 0;
  width: ${props => props.size || "32px"};
  height: ${props => props.size || "32px"};
  margin: 1em auto;
  -webkit-border-radius: 99em;
  -moz-border-radius: 99em;
  border-radius: 99em;
  background-color: ${props => props.theme.color5};
  border: 1px solid ${props => props.theme.color2};
  :hover,
  :focus,
  :active {
    background-color: ${props => props.theme.color6};
    cursor: pointer;
  }
`;

const CircularButton = withTheme(({ theme, icon, onClick, disabled }) => {
  if (disabled) {
    return (
      <CircularDiv>
        <FontAwesomeIcon icon={["fas", icon]} size="2x" color={theme.color2} />
      </CircularDiv>
    );
  }
  return (
    <Circular onClick={onClick}>
      <FontAwesomeIcon icon={["fas", icon]} size="2x" color={theme.color2} />
    </Circular>
  );
});

export default CircularButton;
